import { render, staticRenderFns } from "./LoginLayout.vue?vue&type=template&id=a2476fcc"
import script from "./LoginLayout.vue?vue&type=script&lang=ts"
export * from "./LoginLayout.vue?vue&type=script&lang=ts"
import style0 from "./LoginLayout.vue?vue&type=style&index=0&id=a2476fcc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports